import React from "react"

function IconFile({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="file"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-file"
      {...props}
    >
      <path
        d="M18.83 21.655c.913 0 1.663-.7 1.743-1.592l.007-.16V7.98a.655.655 0 0 0-.121-.38l-.065-.078-4.738-4.844a.655.655 0 0 0-.364-.189l-.104-.008H5.186c-.912 0-1.663.698-1.743 1.59l-.008.16v15.674c0 .913.7 1.663 1.592 1.744l.16.007h13.642zm0-1.31H5.185a.443.443 0 0 1-.432-.352l-.01-.09V4.23c0-.213.152-.39.353-.432l.09-.01 9.346.002.001 4.19c0 .324.237.594.548.645l.107.009h4.082v11.27c0 .183-.111.34-.27.407l-.083.026-.089.009zm-2.988-13.02V4.742l2.528 2.585h-2.528z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconFile
